import api from "../../api";
import galleryAdapter from '../gallery/adapter'

const subAdapter = {
  gallery: galleryAdapter
}

const adapter = {
  responseBodyToForm(input){
    let output = {}

    if(input){
      const {
        blogId,
        judulArtikel = [],
        deskripsiPanjang = [],
        // deskripsiPendek = [],
        kategoriArtikel = [],
        typeAudience = [],
        typeApproach = [],
        typeIssues = [],
        blogsTag = [],
        imgThumbnail,
        imgMainImage,
        blogsGalleries = [],
        submission,
        catatanModerasi,
      } = input

      output = {
        id: blogId,
        title_en: judulArtikel[1],
        title_id: judulArtikel[0],
        content_en: deskripsiPanjang[1],
        content_id: deskripsiPanjang[0],
        categories: matchCategories(kategoriArtikel),
        suitable: matchOptions(typeAudience),
        approach: matchOptions(typeApproach),
        issue: matchOptions(typeIssues),
        tags: matchTags(blogsTag),
        image: {blob: api.base_image+imgMainImage},
        thumbnail: {blob: api.base_image+imgThumbnail},
        gallery_saved: subAdapter.gallery.responseBodyToForm(blogsGalleries),
        submission_status_id: submission,
        reason: catatanModerasi
      };
    }

    return output
  }
}

/** Helpers */
function matchCategories(payload) {
  let result = [];

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index];
      result.push(element.id)
    }
  }

  return result
}

function matchOptions(payload) {
  let result = [];

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index];
      result.push({
        label: element.nama[0],
        value: element.id
      })
    }
  }

  return result
}

function matchTags(payload) {
  let result = [];

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index];
      result.push({
        label: element.pilihanTagId.nama[0],
        value: element.pilihanTagId.id
      })
    }
  }

  return result
}

export default adapter
